import React from "react";

import Message from "./Message";

import "./styles/style.scss";

export const ErrorMessage = (props) => <Message type="error" {...props} />;
ErrorMessage.displayName = "ErrorMessage";

export const HelpMessage = (props) => <Message type="help" {...props} />;
HelpMessage.displayName = "HelpMessage";

export default Message;
